// Xflix Configuration
const config = {
  app: {
    name: import.meta.env.VITE_APP_NAME || 'Xflix',
    version: import.meta.env.VITE_APP_VERSION || '2.0.0',
    environment: import.meta.env.MODE || 'development',
  },
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'https://184b4819-8555-4ffd-b8f5-b4f43107dc32.mock.pstmn.io/v1',
    timeout: parseInt(import.meta.env.VITE_API_TIMEOUT) || 10000,
    endpoints: {
      videos: '/videos',
      upload: '/videos',
      views: (id) => `/videos/${id}/views`,
      votes: (id) => `/videos/${id}/votes`,
    }
  },
  features: {
    enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    debugMode: import.meta.env.VITE_DEBUG_MODE === 'true',
    enableServiceWorker: import.meta.env.VITE_ENABLE_SERVICE_WORKER === 'true',
  },
  ui: {
    debounceDelay: 500,
    itemsPerPage: 20,
    videoPlayer: {
      autoplay: true,
      mute: true,
    }
  }
};

// API URLs
export const API_ENDPOINTS = {
  videos: `${config.api.baseUrl}${config.api.endpoints.videos}`,
  upload: `${config.api.baseUrl}${config.api.endpoints.upload}`,
  views: (id) => `${config.api.baseUrl}${config.api.endpoints.views(id)}`,
  votes: (id) => `${config.api.baseUrl}${config.api.endpoints.votes(id)}`,
};

// Legacy support
const endPoint = API_ENDPOINTS.videos;

export { config };
export default endPoint;